import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { getPublicMenuPath } from '@/lib/tenant/getPublicMenuPath';

export default function CatalogDemoFooter({ routeBid, accent }) {
  return (
    <div className="max-w-7xl mx-auto px-4 pb-6">
      <Card className="p-4 sm:p-5 border-border bg-muted/30">
        <p className="text-sm text-center text-muted-foreground leading-snug mb-3">
          ¿Te gustó la experiencia? Llevá este flujo a tu local con SoluQR.
        </p>
        <div className="flex flex-wrap gap-2 justify-center">
          <Button variant="outline" size="sm" className="text-xs sm:text-sm" asChild>
            <Link to="/register">Crear mi menú</Link>
          </Button>
          <Button size="sm" className="text-xs sm:text-sm" style={{ backgroundColor: accent }} asChild>
            <Link to="/pricing">Ver planes</Link>
          </Button>
          <Button variant="secondary" size="sm" className="text-xs sm:text-sm" asChild>
            <Link to={getPublicMenuPath(routeBid, 'assistant')}>Probar asistente</Link>
          </Button>
        </div>
      </Card>
    </div>
  );
}
